<template>
  <div class="text-center">
    <v-dialog v-model="dialog" width="500" @click:outside="closeDialog">
      <template v-if="edit == null" v-slot:activator="{ on }">
        <v-btn class="primary" v-on="on">{{ $t("surveys.NewSurveyDialog.newQ") }}</v-btn>
      </template>

      <v-form v-model="formValid" ref="form">
        <v-card>
          <div class="primary d-flex justify-space-between align-center">
            <v-card-title class="headline primary white--text" primary-title>{{
              $t("surveys.NewSurveyDialog.newQ")
            }}</v-card-title>
            <v-btn text class="mr-2" icon @click="closeDialog()">
              <v-icon color="white">mdi-close</v-icon>
            </v-btn>
          </div>

          <v-card-text>
            <v-text-field
              v-model="newSurvey.name"
              :rules="[rules.required]"
              :label="this.$t('common.name')"
            ></v-text-field>
            <v-text-field
              v-model="newSurvey.description"
              :label="this.$t('common.description')"
            ></v-text-field>
            <v-select
              :items="questionaireTypes"
              v-model="newSurvey.type"
              :label="this.$t('common.description')"
              item-text="name"
              item-value="id"
              :hint="questionaireHint"
            ></v-select>
            <div class="title mt-2">{{ $t("common.dueDate") }}</div>
            <div class="d-flex flex-row">
              <DatePicker :label="$t('common.date')" v-model="dueDate" />
              <TimePicker
                :label="$t('common.time.time')"
                v-model="dueTime"
                :rules="[rules.required]"
              />
            </div>
            <v-checkbox
              v-model="newSurvey.alarm"
              class="ma-n1"
              :label="$t('surveys.NewSurveyDialog.sendReminder')"
            ></v-checkbox>
            <!-- <div style="border: 1px solid #DDDDDD;" class="pa-2"> -->
            <div class="title">
              {{ $t("surveys.NewSurveyDialog.questions") }}

              {{ $tc("surveys.NewSurveyDialog.questions", questions.length) }}
            </div>
            <div
              style="border: 1px solid #dddddd"
              class="px-4 py-2 ma-2"
              v-for="(question, index) in questions"
              :key="index"
            >
              <div class="d-flex flex-row align-center">
                <v-text-field
                  v-model="question.question"
                  :label="`${$t('surveys.NewSurveyDialog.question_n', { n: index + 1 })}`"
                ></v-text-field>
                <v-btn
                  v-if="questions.length > 1"
                  text
                  class="mr-2"
                  icon
                  @click="questions.splice(index, 1)"
                >
                  <v-icon>mdi-close</v-icon>
                </v-btn>
              </div>

              <div
                class="d-flex flex-row"
                v-for="(answer, answerIndex) in question.options"
                :key="answerIndex"
              >
                <v-text-field
                  class="pl-4"
                  counter
                  maxlength="30"
                  v-model="question.options[answerIndex]"
                  :label="
                    $t('surveys.NewSurveyDialog.option_n', {
                      n: answerIndex + 1,
                    })
                  "
                  prepend-icon="mdi-checkbox-blank-circle-outline"
                ></v-text-field>
                <div v-if="newSurvey.type == 'quiz'">
                  <div v-if="question.answer == answerIndex" class="pa-1">
                    <v-icon color="green">mdi-check</v-icon>
                  </div>
                  <v-btn color="grey " icon v-else @click="setCorrectAnswer(question, answerIndex)">
                    <v-icon>mdi-check</v-icon>
                  </v-btn>
                </div>
                <v-btn
                  icon
                  class="mt-3"
                  v-if="question.options.length > 2"
                  @click="question.options.splice(answerIndex, 1)"
                >
                  <v-icon>mdi-close</v-icon>
                </v-btn>
                <div v-else class="ma-1" style="width: 28px; height: 10px"></div>
              </div>
              <div v-if="question.error" class="error--text caption">
                {{ question.error }}
              </div>

              <div class="d-flex flex-row-reverse">
                <v-btn
                  text
                  v-if="question.options.length < 4"
                  color="primary"
                  @click="question.options.push('')"
                >
                  <v-icon left>mdi-plus</v-icon>
                  {{ $t("surveys.NewSurveyDialog.option") }}
                </v-btn>
              </div>
            </div>

            <v-btn
              text
              color="primary"
              class="mt-2"
              @click="
                questions.push({
                  question: '',
                  options: ['', ''],
                })
              "
            >
              <v-icon left>mdi-plus</v-icon>
              {{ $t("surveys.NewSurveyDialog.question") }}
            </v-btn>
            <p v-if="incompleteFields" class="caption error--text">
              {{ $t("common.fillsRequired") }}
            </p>
          </v-card-text>
          <v-divider></v-divider>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="primary" @click="closeDialog" text v-if="edit">{{
              $t("common.cancel")
            }}</v-btn>
            <v-btn color="primary" @click="createSurvey">{{
              $t(edit ? "common.save" : "common.create")
            }}</v-btn>
          </v-card-actions>
        </v-card>
      </v-form>
    </v-dialog>
  </div>
</template>

<script>
import firestore from "@/firebase/firestore";
import DatePicker from "@/components/Base/DatePickerField";
import TimePicker from "@/components/Base/TimePickerField";
import { format, parseISO } from "date-fns";

export default {
  props: ["oldSurvey", "edit"],
  components: {
    DatePicker,
    TimePicker,
  },
  data: (vm) => ({
    newSurvey: {
      name: "",
      description: null,
      type: "survey",
      alarm: false,
    },

    incompleteFields: null,
    dueDate: new Date().toISOString().substr(0, 10),
    dueTime: null,
    formValid: false,
    questionaireTypes: [
      { id: "quiz", name: vm.$t("surveys.NewSurveyDialog.typeQuiz") },
      {
        id: "survey",
        name: vm.$t("surveys.NewSurveyDialog.typeSurvey"),
      },
    ],
    rules: {
      required: (value) => !!value || "Required.",
    },
    questions: [
      {
        question: "",
        options: ["", ""],
      },
    ],
    dialog: false,
  }),
  computed: {
    questionaireHint() {
      if (this.newSurvey.type === "quiz") {
        return this.$t("surveys.NewSurveyDialog.qHintQuiz");
      }
      return "";
    },
  },
  methods: {
    closeDialog() {
      this.dialog = false;
      this.$emit("closed");
    },
    setCorrectAnswer(question, answerIndex) {
      this.$set(question, "answer", answerIndex);
      this.$delete(question, "error");
    },
    checkOptions() {
      console.log("checking options");
      const emptyQuestions = this.questions.filter((a) => a.question === "");
      if (emptyQuestions.length > 0) {
        console.log("has empty questions");
        emptyQuestions.forEach((question) => {
          this.$set(question, "error", "Don't leave empty questions");
        });
        return false;
      }
      const unansweredQuestions = this.questions.filter((a) => a.options.includes(""));
      console.log(unansweredQuestions);
      if (unansweredQuestions.length > 0) {
        unansweredQuestions.forEach((question) => {
          this.$set(question, "error", "Don't leave empty options");
        });
        return false;
      }

      if (this.newSurvey.type === "quiz") {
        const incompleteQuestions = this.questions.filter((a) => a.answer == null);

        incompleteQuestions.forEach((question) => {
          this.$set(question, "error", "Please select the correct answer");
        });
        if (incompleteQuestions.length > 0) {
          return false;
        }
      }
      return true;
    },
    prepareData() {
      console.log("preparing data");
      this.questions.forEach((question) => {
        this.$delete(question, "error");
        if (this.newSurvey.type !== "quiz") {
          this.$delete(question, "answer");
        }
      });
    },
    adjustForTimezone(date) {
      const timeOffsetInMS = date.getTimezoneOffset() * 60000;
      date.setTime(date.getTime() - timeOffsetInMS);
      return date;
    },
    createSurvey() {
      if (!this.$refs.form.validate()) {
        this.incompleteFields = true;
        return;
      }
      this.incompleteFields = false;

      if (!this.checkOptions()) return;
      console.log("create survey");
      this.prepareData();
      const tripId = this.$store.getters.currentTripId;
      const date = this.adjustForTimezone(parseISO(`${this.dueDate} ${this.dueTime}`));
      const data = {
        ...this.newSurvey,
        questions: this.questions,
        date,
        created: new Date(),
      };

      console.log("finishd creating");
      const id = this.oldSurvey ? this.oldSurvey.id : null;
      firestore.writeTrackedDocument(tripId, "surveys", data, id);
      console.log("finishd creating");

      this.closeDialog();
    },
  },
  watch: {
    oldSurvey(newVal, oldVal) {
      this.dialog = newVal != null && newVal !== oldVal;
      if (newVal) {
        this.newSurvey = {
          name: newVal.name,
          description: newVal.description,
          type: newVal.type,
          alarm: newVal.alarm,
        };

        const date = newVal.date.toDate();
        const timeOffsetInMS = date.getTimezoneOffset() * 60000;
        date.setTime(date.getTime() + timeOffsetInMS);
        this.dueDate = format(date, "yyyy-MM-dd");
        this.dueTime = format(date, "HH:mm");
        this.questions = JSON.parse(JSON.stringify(newVal.questions));
      }
    },
  },
};
</script>
